import { render, staticRenderFns } from "./RiskCheckDailySafetyChecklistAlways.vue?vue&type=template&id=0b682a5e&scoped=true&"
import script from "./RiskCheckDailySafetyChecklistAlways.vue?vue&type=script&lang=js&"
export * from "./RiskCheckDailySafetyChecklistAlways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b682a5e",
  null
  
)

export default component.exports